import { render, staticRenderFns } from "./EndorsementsUpdate.vue?vue&type=template&id=dcbc9a1e"
import script from "./EndorsementsUpdate.vue?vue&type=script&lang=js"
export * from "./EndorsementsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports